import { useState, useEffect } from 'react';
import { GAPromoView } from './ga';

export type TSendCombinedVeiwEvent = {
  position: number;
  creative: string;
};

export const useCombinePromoView = ({ elementBlock }: { elementBlock: string }) => {
  const [eventsToUpdate, setEventsToUpdate] = useState<TSendCombinedVeiwEvent[]>([]);
  const sendCombinedVeiwEvent = (data: TSendCombinedVeiwEvent) => {
    setEventsToUpdate(prevData => [...prevData, data]);
  };

  useEffect(() => {
    if (eventsToUpdate.length) {
      const timer = setTimeout(async () => {
        GAPromoView({
          elementBlock,

          promotions: eventsToUpdate.map(({ position, creative }) => ({
            name: elementBlock,
            creative,
            position,
          })),
        });
        setEventsToUpdate([]);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [eventsToUpdate, elementBlock]);

  return sendCombinedVeiwEvent;
};
